interface FormFieldProps {
  label: string;
  name: string;
  type?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => void;
  required?: boolean;
  placeholder?: string;
  error?: string;
  rows?: number;
  options?: { value: string; label: string }[];
  helpText?: string;
}

export default function FormField({
  label,
  name,
  type = 'text',
  value,
  onChange,
  required = false,
  placeholder = '',
  error = '',
  rows,
  options,
  helpText
}: FormFieldProps) {
  const baseInputClasses = "w-full px-4 py-3 border border-border bg-input text-foreground font-body text-sm focus:outline-none focus:border-foreground transition-colors duration-200";
  
  return (
    <div data-component-id="src/app/application-portal/components/FormField.tsx:31:4" data-component-path="src/app/application-portal/components/FormField.tsx" data-component-line="31" data-component-end-line="81" data-component-file="FormField.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22mb-6%22%7D" className="mb-6">
      <label data-component-id="src/app/application-portal/components/FormField.tsx:32:6" data-component-path="src/app/application-portal/components/FormField.tsx" data-component-line="32" data-component-end-line="35" data-component-file="FormField.tsx" data-component-name="label" data-component-content="%7B%22elementName%22%3A%22label%22%2C%22className%22%3A%22block%20font-body%20text-sm%20font-medium%20mb-2%22%7D" className="block font-body text-sm font-medium mb-2">
        {label}
        {required && <span data-component-id="src/app/application-portal/components/FormField.tsx:34:21" data-component-path="src/app/application-portal/components/FormField.tsx" data-component-line="34" data-component-end-line="34" data-component-file="FormField.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22text-error%20ml-1%22%2C%22textContent%22%3A%22*%22%7D" className="text-error ml-1">*</span>}
      </label>
      
      {type === 'textarea' ? (
        <textarea data-component-id="src/app/application-portal/components/FormField.tsx:38:8" data-component-path="src/app/application-portal/components/FormField.tsx" data-component-line="38" data-component-end-line="46" data-component-file="FormField.tsx" data-component-name="textarea" data-component-content="%7B%22elementName%22%3A%22textarea%22%2C%22name%22%3A%22%5Bvar%3Aname%5D%22%2C%22value%22%3A%22%5Bvar%3Avalue%5D%22%7D"
          name={name}
          value={value}
          onChange={onChange}
          required={required}
          placeholder={placeholder}
          rows={rows || 4}
          className={`${baseInputClasses} resize-none`}
        />
      ) : type === 'select' ? (
        <select data-component-id="src/app/application-portal/components/FormField.tsx:48:8" data-component-path="src/app/application-portal/components/FormField.tsx" data-component-line="48" data-component-end-line="61" data-component-file="FormField.tsx" data-component-name="select" data-component-content="%7B%22elementName%22%3A%22select%22%2C%22name%22%3A%22%5Bvar%3Aname%5D%22%2C%22value%22%3A%22%5Bvar%3Avalue%5D%22%2C%22className%22%3A%22%5Bvar%3AbaseInputClasses%5D%22%7D"
          name={name}
          value={value}
          onChange={onChange}
          required={required}
          className={baseInputClasses}
        >
          <option data-component-id="src/app/application-portal/components/FormField.tsx:55:10" data-component-path="src/app/application-portal/components/FormField.tsx" data-component-line="55" data-component-end-line="55" data-component-file="FormField.tsx" data-component-name="option" data-component-content="%7B%22elementName%22%3A%22option%22%2C%22value%22%3A%22%22%2C%22textContent%22%3A%22Select%20an%20option%22%7D" value="">Select an option</option>
          {options?.map((option) => (
            <option data-component-id="src/app/application-portal/components/FormField.tsx:57:12" data-component-path="src/app/application-portal/components/FormField.tsx" data-component-line="57" data-component-end-line="59" data-component-file="FormField.tsx" data-component-name="option" data-component-content="%7B%22elementName%22%3A%22option%22%7D" key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      ) : (
        <input data-component-id="src/app/application-portal/components/FormField.tsx:63:8" data-component-path="src/app/application-portal/components/FormField.tsx" data-component-line="63" data-component-end-line="71" data-component-file="FormField.tsx" data-component-name="input" data-component-content="%7B%22elementName%22%3A%22input%22%2C%22type%22%3A%22%5Bvar%3Atype%5D%22%2C%22name%22%3A%22%5Bvar%3Aname%5D%22%2C%22value%22%3A%22%5Bvar%3Avalue%5D%22%2C%22className%22%3A%22%5Bvar%3AbaseInputClasses%5D%22%7D"
          type={type}
          name={name}
          value={value}
          onChange={onChange}
          required={required}
          placeholder={placeholder}
          className={baseInputClasses}
        />
      )}
      
      {helpText && (
        <p data-component-id="src/app/application-portal/components/FormField.tsx:75:8" data-component-path="src/app/application-portal/components/FormField.tsx" data-component-line="75" data-component-end-line="75" data-component-file="FormField.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22mt-2%20font-body%20text-xs%20text-muted-foreground%22%7D" className="mt-2 font-body text-xs text-muted-foreground">{helpText}</p>
      )}
      
      {error && (
        <p data-component-id="src/app/application-portal/components/FormField.tsx:79:8" data-component-path="src/app/application-portal/components/FormField.tsx" data-component-line="79" data-component-end-line="79" data-component-file="FormField.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22mt-2%20font-body%20text-xs%20text-error%22%7D" className="mt-2 font-body text-xs text-error">{error}</p>
      )}
    </div>
  );
}